import { mockResponse, request } from './client.js';
import { CATEGORIES, BRANDS } from '../data/categories.js';

/**
 * 分類 / 品牌主檔 API。
 * 只要有設 REACT_APP_API_BASE_URL 就打真實後端，不受 USE_MOCK 影響。
 */

const hasRealBackend = !!process.env.REACT_APP_API_BASE_URL;

export function getCategories() {
  if (hasRealBackend) return request('/api/categories');
  return mockResponse(CATEGORIES);
}

export function getBrands() {
  if (hasRealBackend) return request('/api/brands');
  return mockResponse(BRANDS);
}
